import React, { useEffect, useRef, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { Col, Row, Form } from "react-bootstrap";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { useNavigate } from 'react-router-dom';
import { setTimeOutSync } from "../../utils/setTimeout";
import { getJobPositionByID, createJobPosition, updateJobPositionByID } from "../../api/job_position_api";
import {
    alertValidateData,
    alertConfirmSave,
    alertSaved,
    alertCancel,
    alertNotFound
} from "../../components/alertValid/AlertValid.js"

function AddEditJobPosition() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [txtTitleId, setTxtTitleId] = useState();
    const [editId, setEditId] = useState(null);
    const [activeWork, setActiveWork] = useState(true);
    const [active, setActive] = useState(true);
    const [txtEnDescValue, setTxtEnDescValue] = useState('');
    const [txtThDescValue, setTxtThDescValue] = useState('');
    const [txtEnQualValue, setTxtEnQualValue] = useState('');
    const [txtThQualValue, setTxtThQualValue] = useState('');


    const [dataJobPosition, setDataJobPosition] = useState({
        name: "",
        fullTime: "Full Time",
        partTime: "Part Time",
        fulltime: "",
        responsibilitesEn: "",
        responsibilitesTh: "",
        qualificationEn: "",
        qualificationTh: "",
        active: null,
    });

    const getJobPosition = async (id) => {
        await setLoading(true);
        const respon = await getJobPositionByID(id);
        if(!respon) {
            const res = await alertNotFound();
                if (res.isConfirmed) {
                    // window.location.href = '/backoffice/infoJobPosition'
                    navigateToBack("/infoJobPosition");
                } else {
                    // window.location.href = '/backoffice/infoJobPosition'
                    navigateToBack("/infoJobPosition");
                }
        }
        setTimeout(async () => {
          await setLoading(false);
        }, 1000);
    
        let dataPreview = respon.data.data;
    
        setDataJobPosition({
          ...dataJobPosition,
          name: dataPreview.name??'',
          responsibilitesEn: dataPreview.responsibility_en??'',
          responsibilitesTh: dataPreview.responsibility_th??'',
          qualificationEn: dataPreview.qualification_en??'',
          qualificationTh: dataPreview.qualification_th??'',
          status: dataPreview.active === 1 ? "Active" : "Inactive",
        });
        setTxtEnDescValue(dataPreview.responsibility_en??'');
        setTxtThDescValue(dataPreview.responsibility_th??'');
        setTxtEnQualValue(dataPreview.qualification_en??'');
        setTxtThQualValue(dataPreview.qualification_th??'');
        setActive(dataPreview.active === 1 ? true : false);
        setActiveWork(dataPreview.fulltime === 1 ? true : false);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const createJobPositionData = async () => {
        let body = {
            name: dataJobPosition.name,
            fullTime:dataJobPosition.fullTime,
            partTime:dataJobPosition.partTime,
            fulltime: activeWork === false ? 0 : 1,
            responsibility_en: txtEnDescValue,
            responsibility_th: txtThDescValue,
            qualification_en: txtEnQualValue,
            qualification_th: txtThQualValue,
            active: active === false ? 0 : 1,
          };
          if (
            !body.name ||
            !body.fullTime ||
            !body.partTime ||
            !body.responsibility_en ||
            !body.responsibility_th ||
            !body.qualification_en ||
            !body.qualification_th
          ) {
            await alertValidate();
          } else {
            const result = await alertConfirmSave();
              if (result.isConfirmed) {
                (async () => {
                  await setLoading(true);
                  const response = await createJobPosition(body);
                  setTimeOutSync(() => setLoading(false)).then(async() => {
                    if (response.data.status == "success") {
                        const result = await alertSaved();
                        if (result.isConfirmed) {
                          navigateToBack("/infoJobPosition");
                        }
                    }
                  }).finally(() => setLoading(false))
                })();
              }
          }
    };

    const updateJobPositionData = async (id) => {
        let body = {
            name: dataJobPosition.name,
            fullTime:dataJobPosition.fullTime,
            partTime:dataJobPosition.partTime,
            fulltime: activeWork === false ? 0 : 1,
            responsibility_en: txtEnDescValue,
            responsibility_th: txtThDescValue,
            qualification_en: txtEnQualValue,
            qualification_th: txtThQualValue,
            active: active === false ? 0 : 1,
        };
        if (
            !body.name ||
            !body.fullTime ||
            !body.partTime ||
            !body.responsibility_en ||
            !body.responsibility_th ||
            !body.qualification_en ||
            !body.qualification_th
        ) {
          await alertValidate();
        } else {
            const result = await alertConfirmSave();
            if (result.isConfirmed) {
              await setLoading(true);
              const response = await updateJobPositionByID(id, body);
              setTimeOutSync(() => setLoading(false)).then(async () => {
                if (response.data.status == "success") {
                    const res = await alertSaved();
                    if (res.isConfirmed) {
                      navigateToBack("/infoJobPosition");
                    }
                }else{
                    const res = await alertNotFound();
                        if (res.isConfirmed) {
                            // window.location.href = '/backoffice/infoJobPosition'
                            navigateToBack("/infoJobPosition");
                        } else {
                            // window.location.href = '/backoffice/infoJobPosition'
                            navigateToBack("/infoJobPosition");
                        }
                }
              }).finally(() => setLoading(false))
            }
        }
      };

    const handleActiveBtn = async (idData) => {
        if (idData) {
            updateJobPositionData(idData);
        } else {
            createJobPositionData();
        }
    };
    
    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
            if (res.isConfirmed) {
              navigateToBack("/infoJobPosition");
            }
            else { }
      };

    let apiCalled = useRef(false); // Flag variable

    useEffect(() => {
            apiCalled.current = true;
            let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
                getJobPosition(id);
                setEditId(id);
            }
    }, []);
  return (
    <>
        {isLoading ? <Loading /> : ""}
        <style>
                {`
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                `}
        </style>
        <Header parentmenu={"CAREER JOB"} />
        <Menu
            parentmenu={"infoCareerJob"}
            activemenu={"infoJobPosition"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            {editId ? (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-careers.png" className="ic-user01 me-2" alt="" />
                                EDIT JOB POSITION
                            </font>
                            ) : (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-careers.png" className="ic-user01 me-2" alt="" />
                                ADD JOB POSITION
                            </font>
                            )}
                        </Col>
                    </Row>
                    <Row className="ms-5 mt-3 d-flex align-items-center">
                        <Col xs={3} xl={1} className="p-0">
                            <label className="fontLight font-size03 colorBlack01">
                            Job Position
                            </label>
                        </Col>
                        <Col xs={9} xl={5}>
                            <input
                            type="text"
                            className="inp01 fontLight font-size03"
                            id="name"
                            placeholder="name"
                            value={dataJobPosition.name}
                            onChange={(event) =>
                                setDataJobPosition({
                                ...dataJobPosition,
                                name: event.target.value,
                                })
                            }
                            //disabled={editId ? true : false}
                            />
                        </Col>
                    </Row>
                    <Row className="ms-5 mt-3 d-flex align-items-center">
                        <Col xs={3} xl={1} className="p-0">
                            <label className="fontLight font-size03 colorBlack01">
                            Working Hours
                            </label>
                        </Col>
                        <Col xs={9} xl={5}>
                            <Form>
                                {["radio"].map((type) => (
                                    <div key={`inline1-${type}`} className="my-3">
                                        <Row className='d-flex align-items-center'>
                                            <Col lg={5} xl={3}>
                                                <Form.Check 
                                                    className="fontLight font-size03 colorBlack01"
                                                    inline
                                                    label="Full Time"
                                                    type={type}
                                                    name="group1"
                                                    id={`inline1-${type}-1`}
                                                    aria-label="radio 1"
                                                    checked={activeWork}
                                                    onChange={(e) => setActiveWork(true)}
                                                />
                                            </Col>
                                            <Col lg={5} xl={3}>
                                                <Form.Check 
                                                    className="fontLight font-size03 colorBlack01"
                                                    inline
                                                    label="Part Time"
                                                    type={type}
                                                    name="group1"
                                                    id={`inline1-${type}-2`} 
                                                    aria-label="radio 2"
                                                    checked={!activeWork}
                                                    onChange={(e) => setActiveWork(false)}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                ))}
                            </Form>
                        </Col>
                    </Row>
                    <Row className="ms-5 mt-3 d-flex align-items-center">
                        <Col xs={6}>
                            <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                English
                            </font>
                        </Col>
                        <Col xs={6}>
                            <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                ภาษาไทย
                            </font>
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-2'>
                        <Col xs={6}>
                            {/* <Textarea
                                value={txtEnDescValue}
                                onChange={handleChangeEnDesc}
                                placeholder="Responsibilites"
                            />      */}
                            <CKEditor
                                        editor={Editor}
                                        config={{
                                            fontSize: {
                                            options: [
                                                9,
                                                11,
                                                13,
                                                "default",
                                                17,
                                                19,
                                                21,
                                                24,
                                                28,
                                                32,
                                                36,
                                                38,
                                                42,
                                            ],
                                            },
                                            placeholder:'Duties & Responsibilities',
                                        }}
                                        data={txtEnDescValue}
                                        onChange={(event, editor) =>
                                            setTxtEnDescValue(editor.getData())
                                        }
                                    />
                        </Col>
                        <Col xs={6}>
                            {/* <Textarea
                                value={txtThDescValue}
                                onChange={handleChangeThDesc}
                                placeholder="หน้าที่รับผิดชอบงาน"
                            />      */}
                            <CKEditor
                                        editor={Editor}
                                        config={{
                                            fontSize: {
                                            options: [
                                                9,
                                                11,
                                                13,
                                                "default",
                                                17,
                                                19,
                                                21,
                                                24,
                                                28,
                                                32,
                                                36,
                                                38,
                                                42,
                                            ],
                                            },
                                            placeholder:'หน้าที่และความรับผิดชอบ',
                                        }}
                                        data={txtThDescValue}
                                        onChange={(event, editor) =>
                                            setTxtThDescValue(editor.getData())
                                        }
                                    />
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-2'>
                        <Col xs={6}>
                            {/* <Textarea
                                value={txtEnQualValue}
                                onChange={handleChangeEnQual}
                                placeholder="Qualification"
                            />      */}
                            <CKEditor
                                        editor={Editor}
                                        config={{
                                            fontSize: {
                                            options: [
                                                9,
                                                11,
                                                13,
                                                "default",
                                                17,
                                                19,
                                                21,
                                                24,
                                                28,
                                                32,
                                                36,
                                                38,
                                                42,
                                            ],
                                            },
                                            placeholder:'Qualification',
                                        }}
                                        data={txtEnQualValue}
                                        onChange={(event, editor) =>
                                            setTxtEnQualValue(editor.getData())
                                        }
                                    />
                        </Col>
                        <Col xs={6}>
                            {/* <Textarea
                                value={txtThQualValue}
                                onChange={handleChangeThQual}
                                placeholder="คุณสมบัติ"
                            />      */}
                            <CKEditor
                                        editor={Editor}
                                        config={{
                                            fontSize: {
                                            options: [
                                                9,
                                                11,
                                                13,
                                                "default",
                                                17,
                                                19,
                                                21,
                                                24,
                                                28,
                                                32,
                                                36,
                                                38,
                                                42,
                                            ],
                                            },
                                            placeholder:'คุณสมบัติ',
                                        }}
                                        data={txtThQualValue}
                                        onChange={(event, editor) =>
                                            setTxtThQualValue(editor.getData())
                                        }
                                    />
                        </Col>
                    </Row>
                    <Row className='ms-5 mt-4'>
                        <Col xs={12} className="p-0">
                            <label className="fontLight font-size03 colorBlack01">
                            Status
                            </label>
                        </Col>
                    </Row>
                    <Form className="ml-5">
                        {["radio"].map((type) => (
                            <div key={`inline3-${type}`} className="mt-2 mb-3">
                            <Form.Check
                                className="fontLight font-size03 colorBlack01 checked"
                                inline
                                label="Active"
                                name="group3"
                                type={type}
                                id={`inline3-${type}-1`}
                                checked={active}
                                onChange={(e) => setActive(true)}
                            />
                            <Form.Check
                                className="fontLight font-size03 colorBlack01"
                                inline
                                label="Inactive"
                                name="group3"
                                type={type}
                                id={`inline3-${type}-2`}
                                checked={!active}
                                onChange={(e) => setActive(false)}
                            />
                            </div>
                        ))}
                    </Form>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                    <button
                        className="btn-cancle01"
                        onClick={() => handleClickCancel()}
                    >
                        CANCEL
                    </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                    <button
                        className="btn-save01"
                        onClick={(e) => {
                        handleActiveBtn(editId);
                        }}
                    >
                        SAVE
                    </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default AddEditJobPosition;